import { Logo } from "@nexxt/ui";
import { m } from "../paraglide/messages.js";
import { useDark, useStill } from "./motion/motion";
import { AtelierScene } from "./scenes/atelier-scene";
import { BackstageScene } from "./scenes/backstage-scene";
import { FrontrowScene } from "./scenes/frontrow-scene";
import { OutsideScene } from "./scenes/outside-scene";
import { Chapter } from "./sections/chapter";
import { Footer } from "./sections/footer";
import { GuestlistMorph } from "./sections/guestlist-morph";
import { HeroZoom } from "./sections/hero-zoom";
import { JourneyRail } from "./sections/journey-rail";
import { SuiteMapSection } from "./sections/suite-map-section";
import { UnderTheHood } from "./sections/under-the-hood";

// Nexxt from the inside out (ADR-286): one line of Backstage, the map of the rings, then a chapter per ring.
export function Page() {
  const still = useStill();
  const dark = useDark();
  return (
    <>
      <header className="topbar">
        <a href="#top" aria-label="Nexxt">
          <Logo variant="compact" className="topbar-logo" aria-hidden />
        </a>
        <a href="#map" className="topbar-link">
          {m.nav_map()}
        </a>
      </header>
      <JourneyRail />
      <main id="main">
        <HeroZoom />
        <SuiteMapSection />
        <div className="chapters">
          <Chapter
            id="backstage"
            app="backstage"
            number={1}
            label="Backstage"
            audience={m.backstage_audience()}
            headline={m.backstage_headline()}
            body={m.backstage_body()}
            points={[m.backstage_point_1(), m.backstage_point_2(), m.backstage_point_3(), m.backstage_point_4()]}
            scene={(active) => <BackstageScene active={active} still={still} dark={dark} />}
          />
        </div>
        <GuestlistMorph />
        <div className="chapters">
          <Chapter
            id="atelier"
            app="atelier"
            number={3}
            label="Atelier"
            audience={m.atelier_audience()}
            headline={m.atelier_headline()}
            body={m.atelier_body()}
            points={[m.atelier_point_1(), m.atelier_point_2(), m.atelier_point_3(), m.atelier_point_4()]}
            scene={(active) => <AtelierScene active={active} still={still} dark={dark} />}
          />
          <Chapter
            id="frontrow"
            app="frontrow"
            number={4}
            label="Frontrow"
            audience={m.frontrow_audience()}
            headline={m.frontrow_headline()}
            body={m.frontrow_body()}
            points={[m.frontrow_point_1(), m.frontrow_point_2(), m.frontrow_point_3(), m.frontrow_point_4()]}
            flipped
            scene={(active) => <FrontrowScene active={active} still={still} dark={dark} />}
          />
          <Chapter
            id="outside"
            app="world"
            number={5}
            label={m.outside_label()}
            audience={m.outside_audience()}
            headline={m.outside_headline()}
            body={m.outside_body()}
            points={[m.outside_point_1(), m.outside_point_2(), m.outside_point_3(), m.outside_point_4()]}
            scene={(active) => <OutsideScene active={active} still={still} />}
          />
        </div>
        <UnderTheHood />
      </main>
      <Footer />
    </>
  );
}
